import $ from 'jquery';
import { Formatter } from '@dealersites/dealersite-js-core';

const COB_FACTOR = {
  'weekly': 52,
  'biweekly': 26,
  'monthly': 1,
}

// type can be lease of finance or cash
export function getTotalIMSIncentives(type) {
  let subTotal = $(`.js-non-targeted-incentives.${type}`).data('total');
  return  (subTotal ? subTotal: 0 ) + getTotalIMSTargetedSelected(type);
}

export function getTotalIMSTargetedSelected(type) {
  let total = 0
  $(`.js-targeted-incentive.${type}:checked`).each(function(index) {
    const targetedValue = $(this).parents('.js-targeted-incentive-label').find('.targeted-value');
    const targetedList = $(this).closest('.incentives-list'); 
    total+=targetedValue.data('value'); 
    targetedList.attr('data-total', total);
  });
  return total;
}

export function updateTotalPrice(price, $elemTotal, type, formPrice) {
  price = price - getTotalIMSIncentives(type);
  $elemTotal.each(function () {
    $(this).text(Formatter.price(price, 2));
  });
  if (formPrice) {
    formPrice.val(Formatter.price(price, 2)) 
  }
}

// payment, price (accounted for residual if applies), term, frequency 
export function getCostOfBorrowing(config) {
  const frequencyFactor = COB_FACTOR[config.frequency];
  return ( config.payment * ( config.term / ( frequencyFactor == 1 ? 1 : 12) ) * frequencyFactor ) - ( config.price );
}

export function formatList(list) {
  const values = [];
  list.forEach( function (opt) {
    values.push(opt.primary_name + ": " + Formatter.price(opt.msrp, 2));
  });
  return values.join('\n');
}

